import script from "./PointFlowChart.vue?vue&type=script&setup=true&lang=js"
export * from "./PointFlowChart.vue?vue&type=script&setup=true&lang=js"

import "./PointFlowChart.vue?vue&type=style&index=0&id=90373c9c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-90373c9c"]])

export default __exports__